import { axiosInstance as axios } from '../../utils';
import _ from 'lodash';

import { FETCH_MRR } from "./types";

import { dispatchNotAuthorized } from './authActions';

export const fetchMrr = (options) => async dispatch => {
  const response = await axios.post('/mrr', options);
  if (response.status === 200) {
    dispatch({ type: FETCH_MRR, payload: response.data });
  } else if (response.status === 401) {
    dispatchNotAuthorized();
  }
  return response;
};
